enum SystemOfMeasurement {
  IMPERIAL = "IMPERIAL",
  METRIC = "METRIC"
}

export const IMPERIAL = SystemOfMeasurement.IMPERIAL;
export const METRIC = SystemOfMeasurement.METRIC;

export default SystemOfMeasurement;
